import { api } from "../../App/services/api";
function all(perPage, customer_status_id, plan_id, sort) {
    var uri = "/customers?limit=".concat(perPage);
    if (customer_status_id) {
        uri += "&customer_status_id=".concat(customer_status_id);
    }
    if (plan_id) {
        uri += "&plan_id=".concat(plan_id);
    }
    if (sort) {
        uri += "&sort=".concat(sort);
    }
    return api.get(uri);
}
function allProviders(perPage, page, customer_status_id, plan_id, state, sort, signal, erp_id, due_status) {
    if (page === void 0) { page = 1; }
    var uri = "/customers/providers?limit=".concat(perPage, "&page=").concat(page);
    if (customer_status_id) {
        uri += "&customer_status_id=".concat(customer_status_id);
    }
    if (state) {
        uri += "&state=".concat(state);
    }
    if (plan_id) {
        uri += "&plan_id=".concat(plan_id);
    }
    if (sort) {
        uri += "&sort=".concat(sort);
    }
    if (erp_id) {
        uri += "&erp_id=".concat(erp_id);
    }
    if (due_status && due_status.length > 0) {
        due_status.forEach(function (value) {
            uri += "&due_status[]=".concat(encodeURIComponent(value));
        });
    }
    return api.get(uri, { signal: signal });
}
function paginate(url, customer_status_id, plan_id, state, sort) {
    if (customer_status_id) {
        url += "&customer_status_id=".concat(customer_status_id);
    }
    if (state) {
        url += "&state=".concat(state);
    }
    if (plan_id) {
        url += "&plan_id=".concat(plan_id);
    }
    if (sort) {
        url += "&sort=".concat(sort);
    }
    return api.get(url);
}
function find(customerId) {
    return api.get("/customers/".concat(customerId));
}
function update(customerId, customerData) {
    return api.put("/customers/".concat(customerId), customerData);
}
function destroy(customerId) {
    return api.delete('/customers/' + "".concat(customerId));
}
function impersonate(customerId) {
    return api.get("/customers/impersonate/".concat(customerId));
}
function unImpersonateCustomer(request) {
    return api.post('/customers/unImpersonate', request);
}
function getAllCustomersSuccess() {
    return api.get('/customers/customersSuccess');
}
function getAllClosers() {
    return api.get('/customers/closers');
}
function getAllSellers() {
    return api.get('/customers/sellers');
}
function getAllPlans() {
    return api.get('/customers/plans');
}
function getPlansWithProductsMinimum(customerId) {
    return api.get("/customers/plans_with_products_minimum/".concat(customerId));
}
function getAllStatus() {
    return api.get('/customers/customerStatus');
}
function getAllStates() {
    return api.get('/customers/states');
}
function getAllErps() {
    return api.get('/customers/erps');
}
function getAllHubs() {
    return api.get('/customers/hubs');
}
function search(providersSearch, perPage, signal, customer_status_id, plan_id, erp_id, state, page, sort, due_status) {
    if (page === void 0) { page = 1; }
    var uri = "/customers/search/".concat(encodeURIComponent(providersSearch), "?per_page=").concat(perPage, "&page=").concat(page);
    if (customer_status_id)
        uri += "&customer_status_id=".concat(customer_status_id);
    if (plan_id)
        uri += "&plan_id=".concat(plan_id);
    if (erp_id)
        uri += "&erp_id=".concat(erp_id);
    if (state)
        uri += "&state=".concat(state);
    if (sort)
        uri += "&sort=".concat(sort);
    if (due_status && due_status.length > 0) {
        due_status.forEach(function (value) {
            uri += "&due_status[]=".concat(encodeURIComponent(value));
        });
    }
    return api.get(uri, { signal: signal });
}
function searchSupport(providersSearch) {
    return api.get("/customers/search_support/".concat(providersSearch));
}
function sendMail(customerId) {
    return api.get("/customers/send_first_email/".concat(customerId));
}
function getCustomerReport(reportId) {
    return api.get("/customers/reports/".concat(reportId));
}
function handleProduct(payloadData) {
    return api.post('/customers/handle-product', payloadData);
}
function getAvailableProductsBySupplier(customerId) {
    return api.get("/customers/".concat(customerId, "/available-products"));
}
function AddCustomerCampaing(payloadData) {
    return api.post('/awards/add_customer_to_campaing', payloadData);
}
function updateCustomerEmailPicture(formData) {
    return api.post('/customers/updateCustomerEmailPicture', formData);
}
function sendTestCustomerEmailPicture(formData) {
    return api.post('/customers/sendTestCustomerEmailPicture', formData);
}
function getAllGracePeriods() {
    return api.get('/customers/grace-periods');
}
function changePlan(customerId, planId) {
    return api.post('/customers/change/plan', {
        customer_id: customerId,
        plan_id: planId,
    });
}
function changeGracePeriod(payloadData) {
    return api.post('customers/change/grace-period', payloadData);
}
function sendDissolution(payloadData) {
    return api.post('customers/send/dissolution', payloadData);
}
function createIntegration(customerId, email) {
    var data = { customer_id: customerId };
    if (email && email.trim() !== "") {
        data.email = email;
    }
    return api.post('customers/create_integration', data);
}
function sendCustomerToHomologation(customerId) {
    return api.post('customers/send_customer', { customer_id: customerId });
}
function getProductsWithousPromotion() {
    return api.get('customers/productsWithousPromotion');
}
export default {
    all: all,
    paginate: paginate,
    find: find,
    update: update,
    destroy: destroy,
    impersonate: impersonate,
    unImpersonateCustomer: unImpersonateCustomer,
    getAllCustomersSuccess: getAllCustomersSuccess,
    getAllClosers: getAllClosers,
    getAllSellers: getAllSellers,
    getAllStates: getAllStates,
    getAllPlans: getAllPlans,
    getAllStatus: getAllStatus,
    getAllErps: getAllErps,
    search: search,
    searchSupport: searchSupport,
    getAllHubs: getAllHubs,
    sendMail: sendMail,
    getCustomerReport: getCustomerReport,
    handleProduct: handleProduct,
    getAvailableProductsBySupplier: getAvailableProductsBySupplier,
    AddCustomerCampaing: AddCustomerCampaing,
    allProviders: allProviders,
    updateCustomerEmailPicture: updateCustomerEmailPicture,
    getAllGracePeriods: getAllGracePeriods,
    changePlan: changePlan,
    changeGracePeriod: changeGracePeriod,
    sendDissolution: sendDissolution,
    sendTestCustomerEmailPicture: sendTestCustomerEmailPicture,
    createIntegration: createIntegration,
    sendCustomerToHomologation: sendCustomerToHomologation,
    getProductsWithousPromotion: getProductsWithousPromotion,
    getPlansWithProductsMinimum: getPlansWithProductsMinimum
};
